// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8285 ? "24737fe2" : chunkId) + "." + {"1352":"1294b1b2816a4c4e","8285":"6233738b22fb560a","9238":"ada9d9f5bd749421"}[chunkId] + ".js";
};